import { render, staticRenderFns } from "./InvitationOverview.vue?vue&type=template&id=1267d11c"
import script from "./InvitationOverview.vue?vue&type=script&lang=js"
export * from "./InvitationOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports